/**
 * Canonical Pack Leader product definition ($9.99/month).
 * Keep marketing, UpgradeModal, and upgrade CTAs aligned with this list.
 */

export const PACK_LEADER_MONTHLY_PRICE = '$9.99/month'

/** Bullet list shown in UpgradeModal and pricing cards */
export const PACK_LEADER_BENEFITS = [
  'Parks Safety Intelligence™',
  'Smart Walk Intelligence™',
  'Community Intelligence™',
  'Personalized Picks with AI Fit™',
  'AI-Powered Smart Search',
  '4 park photos per month converted into Park Intelligence (up to 5 photos per submission)',
  'Up to 5 dog profiles',
] as const

export const PACK_LEADER_SMART_SEARCH_LABEL = 'AI-Powered Smart Search'

export const PACK_LEADER_PHOTO_MONTHLY =
  '4 park photos per month converted into Park Intelligence'

export const PACK_LEADER_PHOTO_PER_SUBMISSION = 'Up to 5 photos per submission'

export const PACK_LEADER_PHOTO_FULL = `${PACK_LEADER_PHOTO_MONTHLY} (${PACK_LEADER_PHOTO_PER_SUBMISSION.toLowerCase()})`

export const PACK_LEADER_PHOTO_UPGRADE_CTA = `Upgrade to Pack Leader for ${PACK_LEADER_PHOTO_MONTHLY.toLowerCase()}. ${PACK_LEADER_PHOTO_PER_SUBMISSION}.`
